// 'use client'
// import { useState, useEffect } from 'react'
// import { Switch } from '@headlessui/react'
// import { useRouter } from 'next/navigation'
// import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";



// function SeaViewFilter({ title, dictionary }) {
//     const router = useRouter();

//     const [seaview, setSeaView] = useState(false)

//     const handleUpdateParams = (e) => {
//         console.log(e)
//         let newPathName
//         if (e == true) {
//             newPathName = updateSearchParams(title, e);
//         } else {
//             newPathName = removeSearchParam(title);
//         }

//         router.push(newPathName);
//         router.refresh()
//     };

//     useEffect(() => {
//         const seaViewValue = getSearchParams('seaview')

//         if (seaViewValue == 'true') {
//             setSeaView(true)
//         } else {
//             setSeaView(false)
//         }
//     }, [handleUpdateParams])

//     return (
//         <div className='w-full flex flex-row items-center justify-between mt-2 px-1'>
//             <span className='text-sm text-secondary'>{dictionary.onlyIncludeSeaView}</span>
//             <Switch
//                 checked={seaview}
//                 // onChange={setPetFriendly}
//                 onChange={(value) => {
//                     setSeaView(value)
//                     handleUpdateParams(value)
//                 }}
//                 className={`${seaview ? 'bg-maincolor' : 'bg-forth'
//                     } relative inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
//             >
//                 <span className="sr-only">Only Include Sea View</span>
//                 <span
//                     className={`${seaview ? 'translate-x-6' : 'translate-x-1'
//                         } inline-block h-4 w-4 transform rounded-full bg-white transition`}
//                 />
//             </Switch>
//         </div>
//     )
// }

// export default SeaViewFilter

'use client'
import { useState } from 'react'
import { Switch } from '@headlessui/react'
import { useRouter, useSearchParams } from 'next/navigation'
import { updateSearchParams, removeSearchParam } from "@utils";

function SeaViewFilter({ title, dictionary }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // Initialize the state directly from the URL on component mount
  const initialSeaView = searchParams.get('seaview') === 'true';
  const [seaview, setSeaView] = useState(initialSeaView);

  const handleToggle = (value) => {
    // 1. Update the local state instantly for a quick UI response
    setSeaView(value);

    // 2. Build the new URL without refreshing the whole page
    let newPathName;
    if (value) {
      newPathName = updateSearchParams(title, 'true');
    } else {
      newPathName = removeSearchParam(title);
    }
    
    // 3. Update the URL using router.replace()
    router.replace(newPathName);
  };

  return (
    <div className='w-full flex flex-row items-center justify-between mt-2 px-1'>
      <span className='text-sm text-secondary'>{dictionary.onlyIncludeSeaView}</span>
      <Switch
        checked={seaview}
        onChange={handleToggle}
        className={`${seaview ? 'bg-maincolor' : 'bg-forth'
          } relative inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
      >
        <span className="sr-only">Only Include Sea View</span>
        <span
          className={`${seaview ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition`}
        />
      </Switch>
    </div>
  );
}

export default SeaViewFilter;